export const standardFilterFields = ['parentId', 'tag'] as const;

export const filterFields = [...standardFilterFields] as const;
